const GenerateReport = () => import("./views/GenerateReport.vue");
const AllReports = () => import("./views/AllReports.vue");
export default [
  {
    path: "generate",
    name: "generate-attendance-report",
    component: GenerateReport,
  },
  {
    path: "all",
    name: "attendance-view-reports",
    component: AllReports,
  },
];
